export default __webpack_public_path__ + "static/media/material-k.88267b10.svg";